import React from 'react';

import MobileIcon from '../../Icons/mobileIcon';
import TabletIcon from '../../Icons/tabletIcon';
import DesktopIcon from '../../Icons/desktopIcon';

const ScreenBreakPointSwitcher = ({
  currentBreakPoint,
  onBreakPointSelect
}) => (
  <div className="device-switcher">
    <div
      className={`switch ${currentBreakPoint === 'sm' ? 'is-active' : ''}`}
      onClick={() => onBreakPointSelect('sm')}
    >
      <MobileIcon width={'40px'} />
      <span>Mobile</span>
    </div>
    <div
      className={`switch ${currentBreakPoint === 'md' ? 'is-active' : ''}`}
      onClick={() => onBreakPointSelect('md')}
    >
      <TabletIcon width={'40px'} />
      <span>Tablet</span>
    </div>
    <div
      className={`switch ${currentBreakPoint === 'lg' ? 'is-active' : ''}`}
      onClick={() => onBreakPointSelect('lg')}
    >
      <DesktopIcon width={'40px'} />
      <span>Desktop</span>
    </div>
  </div>
);

export default ScreenBreakPointSwitcher;



// WEBPACK FOOTER //
// ./src/components/library/LookBook/ScreenBreakPointSwitcher.js